module.exports = __webpack_public_path__ + "static/img/2.d69d890.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Personas/2.png
// module id = WGr2
// module chunks = 0